import { defineStore } from 'pinia'
import { ref } from 'vue'
import CheckoutModalViews from "@/enums/CheckoutModalViews"

export const useCheckoutStore = defineStore('checkout', () => {
  const currentView = ref<CheckoutModalViews>(CheckoutModalViews.DISTRIBUTION_DETAILS)
  const setCurrentView = (view: CheckoutModalViews) => {
    currentView.value = view
  }

  const instructions = ref<string | null>(null)
  const setInstructions = (value) => instructions.value = value

  const paymentMethod = ref<string>()
  const setPaymentMethod = (value: string) => paymentMethod.value = value

  const paymentOption = ref<string | null>(null)
  const setPaymentOption = (value: string | null) => paymentOption.value = value

  const guest = ref<{} | null>(null)

  const setGuest = (user) => guest.value = user
  const appendGuest = (data) => guest.value = { ...guest.value, ...data }

  const pendingOrderUuid = ref<string | null>(null)
  const setPendingOrderUuid = (value: string | null) => {
    pendingOrderUuid.value = value
  }

  return {
    currentView,
    setCurrentView,

    instructions,
    setInstructions,

    paymentMethod,
    setPaymentMethod,

    paymentOption,
    setPaymentOption,

    guest,
    setGuest,
    appendGuest,

    pendingOrderUuid,
    setPendingOrderUuid,
  }
}, {
  persist: {
    pick: [ 'instructions', 'giftcardCode', 'couponCode', 'guest' ],
  },
})